import axios from "axios";
import TokenService from "./token";
import { toast } from 'react-toastify';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token && !["/auth/refresh/"].includes(config.url)) {
      config.headers["Authorization"] = 'Bearer ' + token; 
    } 
    if (!["/file/upload/"].includes(config.url)) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/auth/refresh/" && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post("/auth/refresh/", {}, {
            headers: {
              "Authorization" : `Bearer ${TokenService.getLocalRefreshToken()}`,
              "Content-type": "application/json"
            }
          });

          const accessToken = rs.data;
          TokenService.updateLocalAccessToken(accessToken);

          return instance(originalConfig);

        } catch (_error) {
          //REDIRECT TO LOGIN PAGE
        }
      } else {
        if (["/auth/admin/"].includes(originalConfig.url)) {
          console.log(err.response.data);
        } else {
          toast.error(err.response.data);
        }
     }
    } 

    return Promise.reject(err);
  }
);

export default instance;